// extracted by mini-css-extract-plugin
module.exports = {"container":"Label__container___5qY__","label":"Label__label___1kSoI","content":"Label__content___36rdU"};